import { Injectable } from "@angular/core";
@Injectable()
export class ApplicationCaseCommentDto {
    id: number;
    applicationId: number;
    commentText: string;
    userId: string;
    public create() {
      return {
        id: 0,
        applicationId: '',
        commentText: '',
        userId: null,
      }
    }
}
